export class Workflow {
    id: number|undefined;
    active: boolean;
    code: string;
    name: string;
    processPath: string;
    description:string;
    categorie:string;
    parent:string;
    createForm:string;
  }